import httpService from 'services/http/http.service';
import ApiUrl from 'enum/api-url.enum';
import environment from 'utils/environment';
import StorageKeys from 'enum/storages.enum';
import Storages from 'storages';

/**
 * Generate a deterministic cache key from params
 * @param {Object} params - Parameters to hash
 * @returns {string} Cache key
 */
function generateCacheKey(params) {
  const keyString = JSON.stringify(params);
  return StorageKeys.Keys.THIRD_PARTY_CACHE + btoa(keyString).replace(/[+/=]/g, '_');
}

/**
 * Get third-party service data with automatic caching in demo mode
 * @param {Object} params - Query parameters for the API call
 * @returns {Promise<Object>} Response with data property
 */
async function getCallThirdPartyService(params) {
  // Generate cache key from params
  const cacheKey = generateCacheKey(params);

  // Build URL
  let url = ApiUrl.CALLTHIRDPARTYSERVICE;
  if (params) {
    const queryParams = Object.keys(params)
      .map((key) => `${key}=${encodeURIComponent(params[key])}`)
      .join('&');
    url += `?${queryParams}`;
  }

  // Always try to fetch fresh data
  try {
    const response = await httpService.get(url);

    // Cache successful response in demo mode
    if (response?.data && environment.isDemoMode()) {
      const serializedData =
        response.data instanceof Document
          ? new XMLSerializer().serializeToString(response.data)
          : response.data;
      Storages.MainStorage.setItem(cacheKey, serializedData);
    }

    return response;
  } catch (error) {
    // Fallback to cache only on API failure in demo mode
    if (environment.isDemoMode()) {
      const cachedData = Storages.MainStorage.getItem(cacheKey);
      if (cachedData !== null && cachedData !== undefined) {
        return { data: cachedData };
      }
    }

    return { data: null };
  }
}

const obj = { getCallThirdPartyService };

export default obj;
